module.exports = __webpack_public_path__ + "static/total-control-0defae0b2f6a76aa18de7f2d0baa3676.png";